"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.ARROW_TYPE_CLASS_NAME = exports.ARROW_TYPE = exports.ARROW_DISABLED_CLASS_NAME = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Arrow.scss");
var _ARROW_TYPE_CLASS_NAM, _ARROW_TYPE_ICON_NAME;
var ARROW_TYPE = /*#__PURE__*/function (ARROW_TYPE) {
  ARROW_TYPE["next"] = "next";
  ARROW_TYPE["prev"] = "prev";
  return ARROW_TYPE;
}({});
exports.ARROW_TYPE = ARROW_TYPE;
var ARROW_DISABLED_CLASS_NAME = 'cds-Slider-Arrow--Disabled';
exports.ARROW_DISABLED_CLASS_NAME = ARROW_DISABLED_CLASS_NAME;
var ARROW_TYPE_CLASS_NAME = (_ARROW_TYPE_CLASS_NAM = {}, (0, _defineProperty2["default"])(_ARROW_TYPE_CLASS_NAM, ARROW_TYPE.next, 'cds-Slider-Arrow--Next'), (0, _defineProperty2["default"])(_ARROW_TYPE_CLASS_NAM, ARROW_TYPE.prev, 'cds-Slider-Arrow--Prev'), _ARROW_TYPE_CLASS_NAM);
exports.ARROW_TYPE_CLASS_NAME = ARROW_TYPE_CLASS_NAME;
var ARROW_TYPE_ICON_NAME = (_ARROW_TYPE_ICON_NAME = {}, (0, _defineProperty2["default"])(_ARROW_TYPE_ICON_NAME, ARROW_TYPE.next, _Icon.ICON_NAME.arrowRight), (0, _defineProperty2["default"])(_ARROW_TYPE_ICON_NAME, ARROW_TYPE.prev, _Icon.ICON_NAME.arrowLeft), _ARROW_TYPE_ICON_NAME);
var Arrow = function Arrow(_ref) {
  var type = _ref.type;
  var rootClassName = (0, _classnames["default"])('cds-Slider-Arrow', ARROW_TYPE_CLASS_NAME[type]);
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-Slider-ArrowIcon",
    name: ARROW_TYPE_ICON_NAME[type],
    size: _Icon.ICON_SIZE.large
  }));
};
exports.Arrow = Arrow;